import AssignModal from './AssignModal';

export default AssignModal;
